import { createSelector } from '@ngrx/store';
import { NonUSFProductViewModel } from '../models/non-usf-products-view-model';
import {
  allNonUSFProducts,
  allExternalVendors,
  ExternalVendorState,
} from '@usf/ngrx-product';
import { transformNonUsfProductToProduct } from '../transformers/non-usf-products-transformers';

export const getAllNonUSFProductsAsUSFProductsMap = createSelector(
  allNonUSFProducts(),
  allExternalVendors(),
  (productMap, vendors) => {
    const products: NonUSFProductViewModel[] = [];
    productMap.forEach(product => {
      if (!!product) {
        const vendorFound: ExternalVendorState = vendors.find(vendor => {
          return vendor.vendorId === product.vendorId;
        });
        products.push({
          ...product,
          isSelected: false,
          vendorName: vendorFound?.distributorName ?? '',
        });
      }
    });
    return new Map(
      products.map(prod => [
        prod.productNumber,
        transformNonUsfProductToProduct(prod),
      ]),
    );
  },
);
